export const CHECK_IN_SMART_CONSTANTS = {
  // Component IDs
  IDS: {
    AIRPORT_SEARCH: 'check-in-airport-search',
    TABS: 'check-in-tabs',
    FLIGHT_STATUS: 'check-in'
  },

  // Labels and Titles
  LABELS: {
    DESTINATION: 'Destination',
    ORIGIN: 'Origin'
  },

  // Placeholders
  PLACEHOLDERS: {
    SEARCH_AIRPORTS: 'Search airports...'
  },

  // Error Messages
  ERROR_MESSAGES: {
    PREDICTIVE_CITIES_ERROR:
      'Check In Status: Error fetching predictive cities',
    AEM_CONTENT_UNAVAILABLE_ERROR:
      "We're sorry, there was a problem. Please try again later."
  },

  // Floating Label Text
  FLOATING_LABELS: {
    SEARCH_AIRPORTS: 'Search airports...'
  },

  // UI Text
  UI_TEXT: {
    SELECT_AIRPORT: 'Select Airport'
  },

  // HTML Elements and Selectors
  SELECTORS: {
    INPUT: 'input',
    CLOSE_BUTTON:
      'idp-airport-dropdown-modal button[aria-label="Close"], idp-airport-dropdown-modal .close-header-button'
  },

  // Events
  EVENTS: {
    INPUT: 'input'
  },

  // Configuration Values
  CONFIG: {
    SEARCH_MENU_TYPE: 'transparent'
  }
} as const;
